import axios from "axios";

let APIKit = axios.create({
  // baseURL: "https://cotyledonal-undestructibly-jacques.ngrok-free.dev/api",
  // baseURL: "https://inv-api-qa.azurewebsites.net/api",
  baseURL: "https://spark-admin.azurewebsites.net/api",
  // baseURL: "https://gmopen.azurewebsites.net/api", //Dev build
});

APIKit.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    config.headers["ngrok-skip-browser-warning"] = "12321";
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
    console.log(error);
  },
);

export default APIKit;
